<template>
  <div>
    <v-toolbar flat style="margin-left: -10px;padding: 0 0px 0 0;background-color:transparent;">
      <v-toolbar-title><h5 style="font-weight: 500;color:rgba(0, 0, 0, 0.47);font-size: 12px"><v-icon style="font-size: 20px;">mdi-text-short</v-icon> &nbsp;&nbsp;&nbsp;&nbsp;{{ $t('menuType.simpleText') }}&nbsp;&nbsp;&nbsp;&nbsp;</h5></v-toolbar-title>
      <v-divider vertical  style="margin: 0 10px 0 10px;"/>
      <template v-if="$vuetify.breakpoint.mdAndUp">        
        <v-btn-toggle
          v-model="textAlign" 
          @change="handleChangeIsModified"
        >
          <v-btn :value="1" @click="content.Style.TextAlign = 'left'" text>
            <v-icon>mdi-format-align-left</v-icon>
          </v-btn>
          <v-btn :value="2" @click="content.Style.TextAlign = 'center'" text>
            <v-icon>mdi-format-align-center</v-icon>
          </v-btn>
          <v-btn :value="3" @click="content.Style.TextAlign = 'right'" text>
            <v-icon>mdi-format-align-right</v-icon>
          </v-btn>
          <v-btn :value="4" @click="content.Style.TextAlign = 'justify'" text>
            <v-icon>mdi-format-align-justify</v-icon>
          </v-btn>
        </v-btn-toggle>
        <v-btn-toggle
          v-model="style"
          multiple
          @change="handleChangeIsModified"
        >
          <v-btn @click="content.Style.SizeMult = content.Style.SizeMult  + 1" text>
            <v-icon>mdi-format-font-size-increase</v-icon>
          </v-btn>
          <v-btn @click="content.Style.SizeMult = content.Style.SizeMult  - 1" text>
            <v-icon>mdi-format-font-size-decrease</v-icon>
          </v-btn>
          <v-btn @click="content.Style.ToUpperCase = !content.Style.ToUpperCase" text>
            <v-icon>mdi-format-letter-case-upper</v-icon>
          </v-btn>
          <!-- <v-btn :value="4" text>
            <v-icon>mdi-format-color-fill</v-icon>
          </v-btn> -->
        </v-btn-toggle>
        <custom-color-picker
          v-if="TextColor"
          :width="'50px !important'"
          :height="'47px'"
          :icon="'mdi-format-color-text'"
          :color="TextColor"
          :onChangeColor="handleChangeColor"
        />
      </template>
    </v-toolbar>
    <translate
      v-show="!collapseContent"
      v-model="content.Title"
      :languages="languages"
      :label="$t('menuType.text')"
      @input="handleChangeIsModified"
      style="padding: 0 10px 0 10px;"
    />
  </div>
</template>

<script>
  import {
    mapState
  } from 'vuex'
  import Translate from '@/components/Translate'
  import CustomColorPicker from '@/components/CustomColorPicker'
  export default {
    components: {
      Translate,
      CustomColorPicker
    },
    props: {
      content: {
        type: Object,
        required: true
      }
    },
    data: () => ({
      textAlign: null,
      style: null,
      TextColor: null
    }),
    computed: {
      ...mapState('app',['collapseContent', 'ColorContent']),
      languages () {
        return this.$store.state.app.Languages
      }
    },
    mounted () {
      this.textAlign = this.content.Style.TextAlign === 'left' ? 1 :
                        this.content.Style.TextAlign === 'center' ? 2 :
                          this.content.Style.TextAlign === 'right' ? 3 : 4
      this.style = this.content.Style.ToUpperCase ? [2] : []
      this.TextColor = this.content.Style.TextColor ? this.content.Style.TextColor : this.ColorContent
    },
    methods: {
      handleChangeIsModified () {
        if (this.style.indexOf(2) >= 0 && this.style.length > 0) this.style = [2] // solucion temporal para que no se quede seleccionado los elementos
        this.$store.state.app.isModified = true
      },
      handleChangeColor (color) {
        this.TextColor = color
        this.content.Style.TextColor = color
        this.handleChangeIsModified()
      }
    }
  }
</script>

<style scoped>
</style>

